export default {
  agency_key: '',
  mode: '',
  chat_url: '',
  beian: '',
  beian_gn: '',

  address: '南京市雨花台区大周路32号D2幢南2029室',
  uc_host: 'http://user.rw.haimicloud.com',
  site_host: 'http://rw.haimicloud.com',
  special_url: '/',
  site_title: '海米云-软文精准营销平台',
  welcome_title: '海米云 — 软文精准营销平台！',
  site_short_title: '海米云',
  site_subtitle: '软文精准营销平台',
  company_name: '南京海米云信息科技有限公司',
  copyright: '© 2023 南京海米云信息科技有限公司',
  logo: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/230810/4857ce884152d30cb98aee3f7c51c695.png',
  favicon: 'https://xinmeibao.oss-cn-hangzhou.aliyuncs.com/uploads/190/230810/6f72f2d4743f8190ce5d3e9ed63c2040.png',
  payment: '',
  qq: '1069570667',
  tel: '13701402702',
  company_account_id: '150280499',
  company_bank: '中国民生银行股份有限公司南京城南支行',
  company_bank_name: '南京海米云信息科技有限公司',
  alipay_account_id: '13701402702',
  alipay_name: '张成佳',
  alipay_pic: '',
  section_id: 5328719,
  belonger_id: 5328719,
}



//////////////////
// WEBPACK FOOTER
// ./project_config.js
// module id = null
// module chunks = 